import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { OrganizationRole } from "../../common/models/organization-role";
import { User } from "../../common/models/user";
import { AnnualPlan } from "../../common/models/annual-plan";
import { Athlete } from "../../common/models/athlete";
import { Library } from "../../common/models/library";
import { OrganizationMembership } from "../../common/models/organization-membership";
import { AthleteCoach } from "../../common/models/athlete-coach";

export class AnnualPlanRights {
    public Ready: Promise<boolean> = new Promise((resolve, reject) => resolve(false));
    private _itemRightsList: AnnualPlanItemRightsList | null = null;
    private _screenRightsList: AnnualPlanScreenRightList | null = null;
    private _paramsItem: AnnualPlanItemRightsParams | null = null;
    private _paramsScreen: AnnualPlanScreenRightsParams | null = null;
    private _bestOfItemRight = 10000;
    private _bestOfScreenRight = 10000;
    constructor(private _utils: UtilsProvider) {
        this.setDefault();
    }


    public evaluateItemRight(annualPlanRights: string[] | undefined): void {
      this._itemRightsList = mapAnnualPlanRightsToItemRights(annualPlanRights ?? []);
    }

    public evaluateScreenRights(params: AnnualPlanScreenRightsParams): void {

        /**
         * Détermine les droits que l'utilisateur possède
         * pour les commandes générales des écrans.
         */

        this._paramsScreen = params;
        this.setDefault();
        this.setBestOfRole();

        if (!this._screenRightsList) return;
        switch (this._bestOfScreenRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un super-coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_ATHLETE:
            // this._paramsItem.user est un athlète
            this._screenRightsList.list = true;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = false;
            this._screenRightsList.delete = false;
            break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            this._screenRightsList.list = true;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = false;
            this._screenRightsList.delete = false;
            break;

        default:
            // rien
        }
    }

    public getItemRightsList(): AnnualPlanItemRightsList {
        if(!this._itemRightsList) throw new Error('ItemRightsListghtsList is null');
        return this._itemRightsList;
    }

    public getScreenRightsList(): AnnualPlanScreenRightList {
        if(!this._screenRightsList) throw new Error('ScreenRightsList is null');
        return this._screenRightsList;
    }

    public getItemParams(): AnnualPlanItemRightsParams {
        if(!this._paramsItem) throw new Error('ParamsItem is null');
        return this._paramsItem;
    }

    public getScreenParams(): AnnualPlanScreenRightsParams {
        if(!this._paramsScreen) throw new Error('ParamsScreen is null');
        return this._paramsScreen;
    }

    public get LIST() {
        if (this._screenRightsList) {
            return this._screenRightsList.list;
        }
        return false;
    }

    public get ADD() {
        if (this._screenRightsList) {
            return this._screenRightsList.add;
        }
        return false;
    }

    public get EDIT() {
        if (this._screenRightsList) {
            return this._screenRightsList.edit;
        }
        return false;
    }

    public get DELETE() {
        if (this._screenRightsList) {
            return this._screenRightsList.delete;
        }
        return false;
    }

    private setDefault(): void {

        const defaultItemRights: AnnualPlanItemRightsList = {
            view: false,
            edit: false,
            delete: false,
            duplicate: false,
            assign: false,
            active: false,
        };
        this._itemRightsList = defaultItemRights;

        const defaultScreenRights: AnnualPlanScreenRightList = {
            list: false,
            add: false,
            edit: false,
            delete: false,
        };
        this._screenRightsList = defaultScreenRights;

        this._bestOfItemRight = 10000;
        this._bestOfScreenRight = 10000;
    }

    private setBestOfRole() {

        if (this._paramsItem && this._paramsItem.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsItem.rolesIds.length; i++) {
                if (this._paramsItem.rolesIds[i] < this._bestOfItemRight) {
                    this._bestOfItemRight = this._paramsItem.rolesIds[i];
                }
            }
        }

        if (this._paramsScreen && this._paramsScreen.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsScreen.rolesIds.length; i++) {
                if (this._paramsScreen.rolesIds[i] < this._bestOfScreenRight) {
                    this._bestOfScreenRight = this._paramsScreen.rolesIds[i];
                }
            }
        }
    }
}

export interface AnnualPlanItemRightsList {
    view: boolean;
    edit: boolean;
    delete: boolean;
    duplicate: boolean;
    assign: boolean;
    active: boolean;
}

const defaultItemRights: AnnualPlanItemRightsList = {
    view: false,
    edit: false,
    delete: false,
    duplicate: false,
    assign: false,
    active: false,
};

export function mapAnnualPlanRightsToItemRights(annualPlanRights: string[]): AnnualPlanItemRightsList {
  const rights = {...defaultItemRights};

  annualPlanRights.forEach((right: string) => {
    if (right in rights) {
      rights[right as keyof AnnualPlanItemRightsList] = true;
    }
  });

  return rights;
}


export interface AnnualPlanScreenRightList {
    list: boolean;
    add: boolean;
    edit: boolean;
    delete: boolean;
}

export interface AnnualPlanItemRightsParams {
    user: User;
    organizationId: number;
    annualPlan: AnnualPlan;
    rolesIds: number[];
    athletes: Athlete[];
    libraries: Library[];
    organizationMemberships: OrganizationMembership[];
    listOfAthlete: boolean;
    athleteCoachRelations: AthleteCoach[];
}

export interface AnnualPlanScreenRightsParams {
    rolesIds: number[];
}
